import React from "react";
import moment from 'moment';

export default class TaskDetails extends React.Component {
    state = {
        details: [
            { icon: "/assets/icons/person.svg", title: "Task Name", value: this.props.name },
            { icon: "/assets/icons/person.svg", title: "Assigne", value: "" },
            { icon: "/assets/icons/bolt.svg", title: "Priority", value: this.props.taskPriority },
            { icon: "/assets/icons/questionmark.svg", title: "Status", value: this.props.taskStatus },
            { icon: "/assets/icons/alarm-black.svg", title: "Due time", value: this.props.taskDate },
        ]
    }
    render() {
        return (
            <div className="w-100 h-100" style={{ backgroundColor: 'white', padding: "1rem 1rem" }}>
                <div className="confirmation" style={{ width: "100%", height: "100%" }}>
                    <div className="confirmation-header flex">
                        Task Details
                    </div>
                    <div className="" style={{ display: "flex", flexDirection: "column", justifyContent: "left", padding: "2rem 0rem", paddingBottom: "1rem" }}>
                        {this.state.details.map((prop, index) => {
                            return (


                                <div className="request-info  flex-1" style={{ display: "flex", flexDirection: "row", justifyContent: "left", padding: "1rem 1rem", marginBottom: ".5rem" }}>
                                    <img src={prop.icon} className="confirmation-img mrd-2" />
                                    <div>
                                        <p className="confirmation-title">{prop.title}</p>
                                        <p className="confirmation-text">{prop.value}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    }
}